<script lang="ts">
  import { onMount } from "svelte";

  export let smSize = "100%";
  export let mdSize = "100%";
  export let lgSize = "100%";
  export let xlSize = "100%";

  let currentSize = smSize;

  $: if (viewportWidth < mdWidth) {
    currentSize = smSize;
  } else if (viewportWidth >= mdWidth && viewportWidth < lgWidth) {
    currentSize = mdSize;
  } else if (viewportWidth >= lgWidth && viewportWidth < xlWidth) {
    currentSize = lgSize;
  } else if (viewportWidth >= xlWidth) {
    currentSize = xlSize;
  }

  let mdWidth = 768;
  let lgWidth = 1280;
  let xlWidth = 1600;

  let viewportWidth: number;

  onMount(() => {
    const bodyStyle = getComputedStyle(document.body);
    mdWidth = Number(bodyStyle.getPropertyValue("--md").replace(/\D/g, ""));
    lgWidth = Number(bodyStyle.getPropertyValue("--lg").replace(/\D/g, ""));
    xlWidth = Number(bodyStyle.getPropertyValue("--xl").replace(/\D/g, ""));
  });
</script>

<style lang="scss">
  .height-skeleton {
    width: 100%;
  }
</style>

<svelte:window bind:innerWidth={viewportWidth} />

<div class="height-skeleton" style="padding-top: {currentSize};" />
